import { useState, useMemo, useCallback, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";

import DocumentData from "./documents/DocumentData";
import DocumentItem from "./documents/DocumentItem";

import "../styles/document-upload.css";

import { uploadDocument, getDocumentTypes } from "../app/actions/documents";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

function UploadDocuments(props) {
  const { user: currentUser } = useSelector((state) => state.auth);
  const { selectedFacility } = useSelector((state) => state.facility);
  const { types: documentTypes } = useSelector((state) => state.document);

  const [files, setFiles] = useState([]);
  const [selectedFilesData, setSelectedFilesData] = useState([]);
  const [returnedDocumentData, setReturnedDocumentData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDocumentTypes());
  }, []);

  const handleChange = (id, field, value) => {
    setSelectedFilesData((prevItems) => {
      const updatedItems = prevItems.map((item) => {
        if (item.id === id) {
          return { ...item, [field]: value };
        }
        return item;
      });
      return updatedItems;
    });
  };

  const onDrop = useCallback((acceptedFiles) => {
    const filesData = acceptedFiles.map((file, index) => ({
      id: index,
      path: file.path,
      type: null,
      comments: null,
    }));
    setFiles(acceptedFiles);
    setSelectedFilesData(filesData);
  });

  // const removeFile = (prop) => {
  //   console.log("removeFiles", filesRef, files, prop);
  //   // setFiles(acceptedFiles.splice(prop));
  // };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const uploadFile = async () => {
    // console.log("uploadFiles", files.length, selectedFacility);
    if (!files.length) {
      setError("Please add some doucments");
      return;
    }
    const formData = new FormData();
    setIsLoading(true);
    setError("");
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });
    const { value: facilityId } = selectedFacility;
    const { id: userId } = currentUser;

    formData.append("filesData", JSON.stringify(selectedFilesData));
    formData.append("facilityId", facilityId);
    formData.append("userId", userId);

    dispatch(uploadDocument(formData))
      .then((response) => {
        const { data } = response.data;
        setError("");
        setIsLoaded(true);
        setIsLoading(false);
        setReturnedDocumentData(data);
      })
      .catch((error) => {
        console.log("Error", error);
        setIsLoading(false);
        setError("Error uploading files");
      });
  };

  return (
    <section className="upload-container">
      {selectedFacility ? (
        <>
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          <aside>
            <h1 className="green">Files</h1>
            {!isLoaded && (
              <>
                <ul>
                  {files.map((file, index) => (
                    <DocumentItem
                      id={index}
                      key={index}
                      file={file}
                      onChange={handleChange}
                      documentTypes={documentTypes}
                      // onDelete={removeFile}
                    />
                  ))}
                </ul>
                <button disabled={isLoading} onClick={uploadFile}>
                  Upload Files
                </button>
              </>
            )}

            {isLoading && <div>Uploading ...</div>}
            {error && <div>Error: {error}</div>}
            {isLoaded &&
              returnedDocumentData.map((file, key) => (
                <DocumentData key={key} file={file} />
              ))}
          </aside>
        </>
      ) : (
        <>
          <h1>Please select a facility before uploading a document</h1>
        </>
      )}
    </section>
  );
}

export default UploadDocuments;
